<template>
  <div>
    <div class="flex flex-row justify-start">
      <div class="messages text-sm text-gray-700 grid grid-flow-row gap-2">
        <div class="flex items-center group">
          <p
            class="px-6 py-3 rounded-t-full text-base rounded-r-full bg-primary max-w-xs lg:max-w-md text-white"
          >
            {{ question.title }}
            <span v-if="question.multi">(Mehrere möglich)</span>
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-end">
      <div
        class="w-5/6 messages text-sm text-secondary grid grid-flow-row gap-2"
      >
        <div
          v-for="optionGroup of optionGroups"
          :key="optionGroup.key"
          class="flex-wrap flex items-center justify-end group mb-6"
        >
          <p
            class="w-full text-center text-base font-bold"
            v-if="optionGroup.title"
          >
            {{ optionGroup.title }}
          </p>
          <button
            v-for="option of sortedOptions(optionGroup)"
            :key="option.key"
            @click="select(option)"
            class="px-6 py-3 ml-3 mt-3 rounded-t-full rounded-l-full border-4 border-secondary bg-white max-w-xs lg:max-w-md focus:outline-none"
            :class="
              currentSelection.includes(option.key)
                ? 'bg-secondary text-white'
                : ''
            "
          >
            {{ option.title }}
          </button>
        </div>
        <div class="w-full flex px-4 justify-end">
          <button
            v-if="question.step === activeStep && !isLastStep"
            @click="nextStep"
            class="bg-primary text-white text-base font-semibold py-2 px-4 border border-primary disabled:opacity-50 rounded focus:outline-non"
            :disabled="!selection[question.key].length"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { call, get, sync } from 'vuex-pathify'
export default {
  name: 'WizardStep',
  props: {
    question: {
      type: Object
    }
  },
  computed: {
    // file deepcode ignore VueGetterDoesntReturn due to vuex-pathify
    questionsConfig: get('questions/config'),
    activeStep: sync('questions/activeStep'),
    selection: sync('programs/selection'),
    showPrograms: sync('programs/show'),
    isLastStep: get('questions/isLastStep'),
    currentKey() {
      return this.question.key
    },
    currentSelection() {
      return this.selection[this.currentKey]
    },
    isMulti() {
      return this.question.multi
    },
    optionGroups() {
      return this.question.optionGroups.filter((og) => {
        if (!og.condition) return true
        return this.selection[og.condition.stepKey].includes(
          og.condition.required
        )
      })
    }
  },
  methods: {
    toggleSelect: call('programs/toggleSelect'),
    nextStep: call('questions/nextStep'),
    select(option) {
      this.activeStep = this.question.step
      this.toggleSelect({
        option,
        key: this.currentKey,
        multi: this.isMulti
      })
      this.emitCurrentSelectionLength()
    },
    emitCurrentSelectionLength() {
      if (this.isLastStep && this.currentSelection) {
        this.$emit('items', this.currentSelection.length)
      }
    },
    sortedOptions(optionGroup) {
      if (optionGroup.key === 'FWW_KK_OP_01') {
        return optionGroup.options.sort((a, b) => {
          if (a.title > b.title) return 1
          if (a.title < b.title) return -1
          return 0
        })
      }
      return optionGroup.options
    }
  },
  created() {
    if (!(this.currentKey in this.selection))
      this.selection[this.currentKey] = []
  },
  mounted() {
    this.emitCurrentSelectionLength()

    // check for pre-selection #13106
    if (this.currentKey === 'bundeslaender' && this.optionGroups[0]) {
      // this.currentSelection[0] is undefined at start
      if (!this.currentSelection[0] && this.optionGroups[0].preselected) {
        const optionIdx = this.optionGroups[0].options.findIndex(
          (g) => g.key === this.optionGroups[0].preselected
        )

        if (optionIdx > -1) {
          this.select(this.optionGroups[0].options[optionIdx])
        }
      }
    }
    if (this.question.preselected) {
      this.selection[this.question.key] = this.question.preselected
    }
  }
}
</script>

<style lang="scss" scoped></style>
